import React from "react"
import PropTypes from "prop-types"
import { Form } from "antd"
import GooglePlacesNewInput from "modules/google/GooglePlacesNewInput"
import { CustomForm } from "ui/Form"
import { CustomInput } from "ui/Input"
import styles from "./Search.module.css"
import { useDispatch, useSelector } from "react-redux"
import { errorFieldsSelector } from "modules/errors/selectors"
import { CustomInputError } from "ui/CustomInputError"
import { receiveErrors } from "modules/errors/reducer"
import { getName } from "country-list"
import { extractAddressFields } from "../addressUtils"

export const AddressesSearch = ({ setManualAddressEnabled, form, initialValues, externalAddress }) => {
  const dispatch = useDispatch()
  const errors = useSelector(errorFieldsSelector())

  const initialAddress = React.useMemo(() => {
    const { street_address, city, state, zip_code, country } = initialValues
    const countryName = country ? getName(country) : ""
    return [street_address, city, state, zip_code, countryName].filter(Boolean).join(", ")
  }, [initialValues])

  const [meetingLatLng, setMeetingLatLng] = React.useState(initialAddress || null)
  const setCenterLatLng = React.useCallback(() => {}, [])

  React.useEffect(() => {
    if (externalAddress) setMeetingLatLng(externalAddress)
  }, [externalAddress])

  const handlePlaceChanged = ({ target: { value, place, coordinates } }) => {
    dispatch(
      receiveErrors({
        data: { message: { addresses: [] } },
        showToast: false
      })
    )

    if (!value) {
      setMeetingLatLng(null)
      setCenterLatLng(null)
      return
    }

    setMeetingLatLng(value)

    if (coordinates) {
      setCenterLatLng(coordinates)
      form.setFieldsValue({ latitude: coordinates.lat, longitude: coordinates.lng })
    }

    if (place?.address_components) {
      form.setFieldsValue(extractAddressFields(place.address_components))
    }
  }

  return (
    <div className={styles.searchInput}>
      <GooglePlacesNewInput
        meetingLatLng={meetingLatLng}
        setMeetingLatLng={setMeetingLatLng}
        setCenterLatLng={setCenterLatLng}
        setManualAddress={() => setManualAddressEnabled()}
        onChange={handlePlaceChanged}
      />
      <CustomForm form={form} name="profile-information" layout="vertical" initialValues={initialValues} className={styles.hidden}>
        <Form.Item name="street_address"><CustomInput /></Form.Item>
        <Form.Item name="country"><CustomInput /></Form.Item>
        <Form.Item name="state"><CustomInput /></Form.Item>
        <Form.Item name="city"><CustomInput /></Form.Item>
        <Form.Item name="zip_code"><CustomInput /></Form.Item>
        <Form.Item name="latitude" hidden><CustomInput /></Form.Item>
        <Form.Item name="longitude" hidden><CustomInput /></Form.Item>
      </CustomForm>
      {errors.addresses && <CustomInputError errorKey={errors.addresses[0]} />}
    </div>
  )
}

AddressesSearch.propTypes = {
  setManualAddressEnabled: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  externalAddress: PropTypes.string
}
